import React from 'react';
import * as Styled from './styled';
import { useLocale } from 'locale';
import { isNil } from 'lodash';
import { Route } from 'config/routes';

export interface CardProps {
  title: string;
  subtitle: string;
  schoolId: string;
  onClick?: () => void;
  labels?: string[];
  withScore?: boolean;
  isHovered?: boolean;
  madlanEducationIndexInstitutional?: number;
  madlanEducationIndexCityAverage?: number;
  madlanEducationIndexNationalAverage?: number;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const Card: React.FC<CardProps> = (props) => {
  const {
    title,
    subtitle,
    labels = [],
    onClick,
    schoolId,
    withScore,
    isHovered,
    onMouseEnter,
    onMouseLeave,
    madlanEducationIndexInstitutional,
    madlanEducationIndexCityAverage,
    madlanEducationIndexNationalAverage,
  } = props;

  const { t } = useLocale();

  const items = withScore ? [
    {
      key: 'institutional',
      value: madlanEducationIndexInstitutional ? `${madlanEducationIndexInstitutional}/100` : t('schoolPage.widget.school.empty.score'),
      copy: t('schoolPage.widget.school.madlan.index', { kind: 'current' }),
      isActive: true,
    },
    {
      key: 'cityAverage',
      value: madlanEducationIndexCityAverage,
      copy: t('schoolPage.widget.school.madlan.index', { kind: 'city' }),
      isActive: false,
    },
    {
      key: 'nationalAverage',
      value: madlanEducationIndexNationalAverage ? Math.round(madlanEducationIndexNationalAverage) : madlanEducationIndexNationalAverage,
      copy: t('schoolPage.widget.school.madlan.index', { kind: 'national' }),
      isActive: false,
    },
  ].filter(i => !isNil(i.value)) : [];

  return (
    <Styled.Root routeName={Route.School} routeParams={{ id: schoolId }} target="_blank" isHovered={isHovered} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Styled.Title weight="bold">{title}</Styled.Title>
        <Styled.SubTitle>{subtitle}</Styled.SubTitle>
        {labels && labels.length ? (
          <Styled.LabelsBox>
            {labels.map((label, index) => (
              <Styled.Label weight="bold" key={index}>{label}</Styled.Label>
            ))}
          </Styled.LabelsBox>
        ) : null}
      </div>
      {items.length ? (
        <Styled.MadlanIndexBox>
          {items.map(item => (
            <div key={item.key}>
              <Styled.MadlanIndexTitle isActive={item.isActive}>
                {item.copy}
              </Styled.MadlanIndexTitle>
              <Styled.MadlanIndexValue weight="bold" isActive={item.isActive}>
                {item.value}
              </Styled.MadlanIndexValue>
            </div>
          ))}
        </Styled.MadlanIndexBox>
      ) : null}
    </Styled.Root>
  );
};
